import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { LEGAL } from "../data/legalContent";

const Block = ({ block }) => {
  switch (block.type) {
    case "h":
      return <h2 className="mt-6 font-display text-xl font-600 uppercase tracking-wide text-[#e0574c] md:text-2xl">{block.text}</h2>;
    case "p":
      return <p className="text-sm leading-relaxed text-[#c8c8c8] md:text-base">{block.text}</p>;
    case "ul":
      return (
        <ul className="ml-5 list-disc space-y-1.5 text-sm leading-relaxed text-[#c8c8c8] md:text-base">
          {block.items.map((it, i) => (
            <li key={i}>{it}</li>
          ))}
        </ul>
      );
    case "links":
      return (
        <div className="flex flex-col gap-2">
          {block.items.map((l, i) => (
            <a key={i} href={l.href} target="_blank" rel="noopener noreferrer" className="text-sm text-[#e0a82e] underline underline-offset-2 hover:text-[#f2b93f]">
              {l.text}
            </a>
          ))}
        </div>
      );
    case "email":
      return (
        <a href={`mailto:${block.address}`} className="inline-flex items-center gap-2 text-sm font-600 text-[#e0a82e] hover:underline">
          <Mail className="h-4 w-4" /> {block.address}
        </a>
      );
    default:
      return null;
  }
};

const LegalPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const slug = location.pathname.replace(/^\//, "");
  const page = LEGAL[slug];

  if (!page) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-16 md:px-8">
        <p className="text-[#c4c4c4]">Page not found.</p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-3xl px-4 py-14 md:px-8">
      <button
        onClick={() => navigate("/")}
        className="mb-8 inline-flex items-center gap-2 font-display text-sm uppercase tracking-wide text-[#e0574c] transition-colors hover:text-[#e0a82e]"
      >
        <ArrowLeft className="h-4 w-4" /> Back to Home
      </button>
      <h1 className="font-display text-4xl font-700 uppercase tracking-wide text-[#e0a82e] md:text-5xl">{page.title}</h1>
      <p className="mt-2 text-sm italic text-[#9a9a9a]">{page.updated}</p>
      <div className="mt-6 flex flex-col gap-3">
        {page.blocks.map((b, i) => (
          <Block key={i} block={b} />
        ))}
      </div>
    </div>
  );
};

export default LegalPage;
